import { AttentePaiementStep, ConsentementEmailStep, DocumentsStep, showConsentementEmailStep, PrelevementStep, SignatureStep, ValidationPaiementAvenant, ValidationStep } from '@workspace/core-ts/components';
import type { StepProps } from '@workspace/core-ts/utils';
import { addIndexToSteps } from '@workspace/core-ts/utils';
import { AvReasonKeyValue } from '../AvReason';
import Bienvenue from './1-bienvenue';
import Vehicules from './3-vehicules';
import Declaration from './4-declaration';
import Garanties from './5-garanties';
import InformationContact from './6-information-contact';
import TarificationContainer from './7-tarification';
import Informations from './8-informations';
import Recapitulatif from './9-recapitulatif';
import PaiementLivraison from './10-paiement';
import SelectionMotifAvenant from './selection-motif-avenant';
import SelectionVehicules from './selection-vehicules';

// eslint-disable-next-line react-refresh/only-export-components
export default addIndexToSteps([
    {
        slug: 'bienvenue',
        title: 'Bienvenue',
        path: '/',
        element: Bienvenue,
        isAvenant: false,
    },
    {
        slug: 'avenant',
        title: 'Avenant',
        path: '/avenant',
        element: SelectionMotifAvenant,
        isAffaireNouvelle: false,
    },
    {
        slug: 'selection-vehicules',
        title: 'Sélection des véhicules',
        path: '/selection-vehicules',
        element: SelectionVehicules,
        isAffaireNouvelle: false,
        avenantMotifs: [AvReasonKeyValue.CHANGEMENT_DE_GARANTIES],
    },
    {
        slug: 'vehicules',
        title: 'Véhicules',
        path: '/vehicules',
        element: Vehicules,
        avenantMotifs: [AvReasonKeyValue.AJOUT_DE_VEHICULES],
    },
    {
        slug: 'declaration',
        title: 'Déclaration',
        path: '/declaration',
        element: Declaration,
    },
    {
        slug: 'garanties',
        title: 'Garanties',
        path: '/garanties',
        element: Garanties,
    },
    {
        slug: 'information-contact',
        title: 'Contact',
        path: '/information-contact',
        element: InformationContact,
        source: ['site'],
    },
    {
        slug: 'tarification',
        title: 'Tarification',
        path: '/tarification',
        element: TarificationContainer,
    },
    {
        // Uniquement pour les apporteurs qui recueillent le consentement e-mail, hors avenant
        slug: 'preferences-email',
        title: 'Vos préférences',
        path: '/preferences-email',
        element: ConsentementEmailStep,
        isAvenant: false,
        showWhen: showConsentementEmailStep,
    },
    {
        slug: 'informations',
        title: 'Informations',
        path: '/informations',
        element: Informations,
    },
    {
        slug: 'recapitulatif',
        title: 'Récapitulatif',
        path: '/recapitulatif',
        element: Recapitulatif,
    },
    {
        slug: 'prelevement',
        title: 'Prélèvement',
        path: '/prelevement',
        element: () => <PrelevementStep showConditions={false} />,
    },
    {
        slug: 'validation-paiement-avenant',
        title: 'Validation',
        path: '/validation-paiement-avenant',
        element: ValidationPaiementAvenant,
        isAffaireNouvelle: false,
    },
    {
        slug: 'paiement',
        title: 'Paiement',
        path: '/paiement',
        element: PaiementLivraison,
        isAvenant: false,
    },
    {
        slug: 'attente-paiement',
        title: 'Attente de paiement',
        path: '/attente-paiement',
        element: () => <AttentePaiementStep />,
        source: ['conseiller', 'courtier'],
        isAvenant: false,
    },
    {
        slug: 'validation',
        title: 'Validation',
        path: '/validation',
        element: () => <ValidationStep />,
        isAvenant: false,
    },
    {
        slug: 'signature',
        title: 'Signature électronique',
        path: '/signature',
        element: () => <SignatureStep showHeaderIcon={true} />,
        source: ['site', 'concessionnaire'],
    },
    {
        slug: 'pieces-justificatives',
        title: 'Pièces justificatives',
        path: '/envoi-des-pieces',
        element: () => <DocumentsStep showIcon={true} />,
    },
]) as StepProps[];
